import { IntlFormatters } from '@formatjs/intl/src/types';
import moment from 'moment/moment';

import { createDate } from 'lib/date';
import messages from './messages';

type Duration = {
  endYear: number | null;
  formatMessage: IntlFormatters['formatMessage'];
  startYear: number;
  endMonth?: number | null;
  isShortFormat?: boolean;
  startMonth?: number | null;
};

export const yearsAndMonthsDuration = ({
  endYear,
  startYear,
  formatMessage,
  endMonth = null,
  startMonth = null,
  isShortFormat = false,
}: Duration): string => {
  const defaultStartMonth = endMonth ? 0 : null;
  const startDate = createDate(startYear, startMonth ?? defaultStartMonth);
  const endDate = createDate(endYear, endMonth);

  const duration = Math.round(moment.duration(moment(endDate).diff(moment(startDate))).asMonths());
  const years = Math.floor(duration / 12);
  const months = duration - years * 12;
  const yearsMsg = years
    ? formatMessage(messages[isShortFormat ? 'yearsShort' : 'years'], {
        years,
      })
    : '';
  const monthsMsg = months
    ? formatMessage(messages[isShortFormat ? 'monthsShort' : 'months'], {
        months,
      })
    : '';

  return `${yearsMsg} ${monthsMsg}`.trim();
};

export const lessThanPeriodDuration = ({
  formatMessage,
  endMonth = null,
  startMonth = null,
  isShortFormat = false,
}: Pick<Duration, 'formatMessage' | 'isShortFormat' | 'startMonth' | 'endMonth'>): string => {
  const period = startMonth !== null && endMonth !== null ? 'Month' : 'Year';

  return formatMessage(
    messages[
      (isShortFormat ? `lessThan${period}Short` : `lessThan${period}`) as keyof typeof messages
    ],
    { lt: '<' }
  );
};

export const hasDiffDates = ({
  endYear,
  endMonth,
  startMonth,
  startYear,
}: Pick<Duration, 'endMonth' | 'startMonth' | 'endYear' | 'startYear'>) => {
  const defaultStartMonth = endMonth ? 0 : null;
  const startDate = createDate(startYear, startMonth ?? defaultStartMonth);
  const endDate = createDate(endYear, endMonth);

  return !!moment(startDate).diff(moment(endDate));
};
